import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; //引入store
import ElementUI from "element-ui";
import mixin from "./mixins";
import "element-ui/lib/theme-chalk/index.css";
import "./utils/flexible.js";

// 导入全局样式表
import "./assets/style/index.scss";
//导入字体图标
import "./assets/fonts/iconfont.css";
import { setToken, getToken } from "@/utils/auth";

import Pagination from "@/components/Pagination";
import CustInformation from "@/components/CustInformation";
import "./permission"; // permission control
//引入v-viewer
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import SelectQuery from "./components/SelectQuery/index.vue";
import { baseURLapp } from "@/api/anyURL.js";

// 获取 URL 中的 token 参数
function getTokenFromUrl() {
  // 获取完整的 URL 并解析所有查询参数（包括 hash 部分）
  const url = window.location.href;
  const queryString = url.split("?")[1];
  if (!queryString) return null;

  const params = new URLSearchParams(queryString);
  return params.get("token");
}
var baseURL = baseURLapp.replace("https://", "");
const isTestEnv = baseURL.includes("testyygproapi.yaojuli.com");
console.log("baseURLapp:", baseURL);
var testToken = "";
if (isTestEnv || window.location.origin.includes("testcw.yaojuli.com")) {
  console.log("测试环境");
  //测试环境
  testToken =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ0aGluay1qd3QiLCJ1c2VySWQiOiI2OTg5NzlhZWY3NWU1MjBiNTcwMmYxOWUiLCJqd3Rfc2NlbmUiOiJkZWZhdWx0IiwianRpIjoiZGVmYXVsdDo2OWQ1YWNjZWEyZjhmMy41NjQ5MTQ0OSIsImlhdCI6MTc3NTYxMTA4NiwibmJmIjoxNzc1NjExMDg2LCJleHAiOjI0MDYzMzEwODZ9.B6oaX7ZNkg3hSk1VxMT52pES-AkMLUx9L5zZ8xOU3IM";
} else {
  console.log("正式环境");
  //正式环境
  // testToken =
  //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ0aGluay1qd3QiLCJ1c2VySWQiOiI2OWE5NDc3NDRlOTM3MDI2ZDkwMmM0ZjQiLCJqd3Rfc2NlbmUiOiJkZWZhdWx0IiwianRpIjoiZGVmYXVsdDo2YTRjYTQwOGNlNjI2NS4wNzY2MjEyMiIsImlhdCI6MTc4MzQwNzYyNCwibmJmIjoxNzgzNDA3NjI0LCJleHAiOjI0MTQxMjc2MjR9.ZewG4RqCfvKL2rHDK6F5prlWJdXfWMbKwFVLZldRNh4";
  testToken = "";
}
var token = getTokenFromUrl() || testToken;
if (token) {
  // 存入 Vuex
  store.commit("SET_TOKEN", token);
  // 存入 localStorage
  localStorage.setItem("token", token);

  setToken(token);
}

// 智为云菜单——集团共享页面路由名称（不含无权访问页）
const GROUP_SHARED_ROUTE_NAMES = [
  "BumUpdated",
  "GroupCustomerList",
  "PushRecords",
  "ShareSended",
  "ShareReceived",
  "CustomerData",
  "ChangeLog",
  "GroupManagement",
  "CodeManagement",
];
const NO_ACCESS_ROUTE_NAME = "NoAccess";

// 判断目标路由是否属于集团共享菜单
function isGroupSharedRoute(route) {
  return GROUP_SHARED_ROUTE_NAMES.includes(route && route.name);
}

// 集团共享页面无 token 时跳转无权访问页，且使用 replace 避免浏览器返回
router.beforeEach((to, from, next) => {
  if (to.name === NO_ACCESS_ROUTE_NAME) {
    next();
    return;
  }
  if (isGroupSharedRoute(to) && token == "") {
    next({ name: NO_ACCESS_ROUTE_NAME, replace: true });
    return;
  }
  next();
});

Vue.use(Viewer, {
  defaultOptions: {
    // 全局默认配置
    inline: true,
    navbar: false,
    title: false,
    fullscreen: false,
    zIndex: 999999,
    toolbar: {
      zoomIn: 4,
      zoomOut: 4,
      oneToOne: 4,
      reset: 4,
      rotateLeft: 1,
      rotateRight: 1,
    },
  },
});

// 全局组件挂载
Vue.component("Pagination", Pagination);
Vue.component("CustInformation", CustInformation);
Vue.component("SelectQuery", SelectQuery); //搜索统一输入框
Vue.config.productionTip = false;
Vue.mixin(mixin);
// Vue.prototype.OnsetToken = function (token) {
//   store.commit("SET_TOKEN", token);   // 直接提交 mutation
//   localStorage.setItem("token", token);
// };

// 全局组件挂载
Vue.use(ElementUI, { size: "small" });
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
